import { createSelector } from 'reselect';
import { RootState } from 'data';
import { OrganisationState } from './types';

const organisationManagementSelector = (state: RootState) => state.organisationManagement;

const createOrganisationSelector = <T extends keyof OrganisationState>(field: T) =>
  createSelector([organisationManagementSelector], (state): OrganisationState[T] => state[field]);

// Reusable selector generator
const makeSubSelector = <
  K extends keyof OrganisationState,
  F extends keyof NonNullable<OrganisationState[K]>
>(
  key: K,
  field: F
) =>
  createSelector([createOrganisationSelector(key)], (state) => {
    if (typeof state === 'object' && state !== null && !Array.isArray(state)) {
      return (state as NonNullable<OrganisationState[K]>)[field];
    }
    return undefined;
  });

// -----------------------
// Organisation Details
// -----------------------

export const selectOrganisationDetailsRange = makeSubSelector(
  'organisationDetails',
  'selectedRange'
);

// -----------------------
// Organisation Activity
// -----------------------

export const selectOrganisationActivityRange = makeSubSelector(
  'organisationActivity',
  'selectedRange'
);

// -----------------------
// Dashboard Activity
// -----------------------

export const selectOrganisationDashboardActivity = makeSubSelector(
  'organisationDashboardActivity',
  'data'
);
export const selectOrganisationDashboardActivityRange = makeSubSelector(
  'organisationDashboardActivity',
  'selectedRange'
);

export const selectOrganisationDashboardLineActivity = makeSubSelector(
  'organisationDashboardLineActivity',
  'data'
);

export const selectOrganisationDashboardLineActivityRange = makeSubSelector(
  'organisationDashboardLineActivity',
  'selectedRange'
);
